<template lang="pug">
  aside.main-sidebar(v-if="login_user", data-testid="side-menu")
    section.sidebar(style="height: auto;")
      .spacer-box
      ul.sidebar-menu.tree(ref="tree")
        li
          a.sidebar-toggle.sidebar-toggle-open(href='#', data-toggle='push-menu' @click.prevent="saveSidebar" :data-collapse-screen-size="767 - 17" title="開く")
            i.fa.fa-fw.fa-lg.fa-angle-double-right
          a.sidebar-toggle.sidebar-toggle-close(href='#', data-toggle='push-menu' @click.prevent="saveSidebar" :data-collapse-screen-size="767 - 17" title="閉じる")
            i.fa.fa-fw.fa-lg.fa-angle-double-left

        //------------------------------------------------------------
        //- 一般メニュー
        //------------------------------------------------------------
        template(v-if="!isAdminPage")
          li.header メンテナンス
          li(v-if="!isMgmt", data-testid="sidebar-queued")
            router-link(:to="{name:'queued', params: {init: true}}" title="登録待ちの名刺" data-testid="-link-maint-pueued")
              i.fa.fa-fw.fa-hourglass-half
              span 登録待ちの名刺
              .badge.bg-blue.pull-right(v-if="queuesCount") {{getBadgeCount(queuesCount)}}
          li(v-if="!isMgmt", data-testid="sidebar-readerr")
            router-link(:to="{name: 'readerr', params: {init: true}}" title="読み取り不能名刺" data-testid="-link-maint-readerr")
              //i.fa.fa-fw.fa-eye-slash
              i.fa.fa-fw.fa-exclamation-triangle
              span 読み取り不能名刺
              .badge.bg-blue.pull-right(v-if="errorsCount") {{getBadgeCount(errorsCount)}}
          li(data-testid="sidebar-noimage")
            router-link(:to="{name: 'noimage', params: {init: true}}" title="画像未登録名刺" data-testid="-link-maint-noimage")
              i.fa.fa-fw.fa-question-circle-o
              span 画像未登録名刺
              .badge.bg-blue.pull-right(v-if="noimageCount") {{getBadgeCount(noimageCount)}}
          li(data-testid="sidebar-merge")
            router-link(:to="{name:'merge-persons-list', params: {init: true}}" title="名寄せ候補名刺" data-testid="-link-maint-duplicated")
              //i.fa.fa-fw.bcard-fa-duplicate-manage
              i.fa.fa-fw.fa-users
              span 名寄せ候補名刺
              .badge.bg-blue.pull-right(v-if="nonjudgedCount") {{getBadgeCount(nonjudgedCount)}}

          li.header 名刺BOX
          li.has-action(v-if="!isMgmt", data-testid="sidebar-box")
            router-link(:to="{name: 'box', params: {init: true}}" title="自分の名刺" data-testid="-link-box-my")
              i.fa.fa-fw.fa-address-card-o
              span 自分の名刺
            pin(v-model="pinnedMenu", target="my")
          li.has-action(data-testid="sidebar-boxall")
            router-link(:to="{name: 'box-all', params: {init: true}}" title="すべての名刺" data-testid="-link-box-all")
              i.fa.fa-fw.fa-archive
              span すべての名刺
            pin(v-model="pinnedMenu", target="all")
          li.has-action(v-if="!isMgmt", data-testid="sidebar-favorite")
            router-link(:to="{name: 'favorite', params: {init: true}}" title="お気に入り" data-testid="-link-box-fav")
              i.fa.fa-fw.fa-star
              span お気に入り
            pin(v-model="pinnedMenu", target="fav")
          li.has-action(v-if="!isMgmt", data-testid="sidebar-browsing")
            router-link(:to="{name: 'browsing', params: {init: true}}" title="最近見た名刺" data-testid="-link-box-acc")
              i.fa.fa-fw.fa-eye
              span 最近見た名刺
            pin(v-model="pinnedMenu", target="acc")

        // 社長レビュー前に隠しておく
        //template(v-if="!isAdminPage")
          li.header 保存済みの検索条件
          li.has-action(data-testid="sidebar-saved-conds")
            router-link(:to="{name: 'top', params: {init: true}, query: {all: 1, sid: '1234567890'}}" title="フォロー対象")
              i.fa.fa-fw.fa-archive
              span フォロー対象
            a.action.pull-right(href="#" title="削除する")
              i.fa.fa-times
          li.has-action(data-testid="sidebar-saved-conds")
            router-link(:to="{name: 'top', params: {init: true}, query: {all: 1, sid: '1234567890'}}" title="適当な名前を付けてあいうえおかきくけこ")
              i.fa.fa-fw.fa-archive
              span 適当な名前を付けてあいうえおかきくけこ
            a.action.pull-right(href="#" title="削除する")
              i.fa.fa-times

        //------------------------------------------------------------
        //- システム管理メニュー
        //------------------------------------------------------------
        template(v-else-if="login_user && login_user.is_admin", data-testid="side-menu-admin")
          li.header

          li
            router-link(:to="{name: 'admin', params: {init: true}}" title="設定状況")
              i.fa.fa-fw.fa-tachometer
              span 設定状況

          li.treeview(data-type='user' :class="{'menu-open': user.isOpen}", data-testid="menu-block-user")
            a(href="#", @click="isOpenMenu($event)")
              i.fa.fa-fw.fa-user-plus
              i.fa.fa-angle-right.hidden
              span ユーザー管理
              span.pull-right-container
                i.fa.fa-angle-left.pull-right
            ul.treeview-menu(:style="{'display': user.display}")
              li
                router-link(:to="{name: 'user', params: {init: true}}" title="ユーザー管理", data-testid="user-master")
                  span ユーザー管理
              li
                router-link(:to="{name: 'user-import', params: {init: true}}" title="ユーザー情報のインポート")
                  span ユーザー情報のインポート
              li
                router-link(:to="{name: 'user-export', params: {init: true}}" title="ユーザー情報のエクスポート")
                  span ユーザー情報のエクスポート
              li
                router-link(:to="{name: 'user-setting', params: {init: true}}" title="ユーザー情報変更不可設定")
                  span ユーザー情報変更不可設定

          li.treeview(data-type='group' :class="{'menu-open': group.isOpen}")
            a(href="#", @click="isOpenMenu($event)")
              i.fa.fa-fw.fa-users
              i.fa.fa-angle-right.hidden
              span 組織管理
              span.pull-right-container
                i.fa.fa-fw.fa-angle-left.pull-right
            ul.treeview-menu(:style="{'display': group.display}")
              li
                router-link(:to="{name: 'group', params: {init: true}}" title="組織管理")
                  span 組織管理
              li
                router-link(:to="{name: 'group-import', params: {init: true}}" title="組織情報のインポート")
                  span 組織情報のインポート
              li
                router-link(:to="{name: 'group-export', params: {init: true}}" title="組織情報のエクスポート")
                  span 組織情報のエクスポート
          li
            router-link(:to="{name: 'mgtag', params: {init: true}}" title="タグ管理")
              i.fa.fa-fw.fa-tags
              span タグ管理
          li
            router-link(:to="{name: 'extrigger', params: {init: true}}" title="きっかけ管理")
              i.fa.fa-fw.fa-thumbs-o-up
              span きっかけ管理
          li
            router-link(:to="{name: 'exlocation', params: {init: true}}" title="交換場所管理")
              i.fa.fa-fw.fa-map-marker
              span 交換場所管理
          // Ph.4は不要
          //li
          //  router-link(:to="{name: 'extracolumn', params: {init: true}}" title="人物拡張項目管理")
          //    i.fa.fa-fw.fa-wrench
          //    span 人物拡張項目管理

          li.header

          li.treeview(data-type='envsetting' :class="{'menu-open': envsetting.isOpen}")
            a(href="#", @click="isOpenMenu($event)")
              i.fa.fa-fw.fa-sliders
              i.fa.fa-angle-right.hidden
              span 基本設定
              span.pull-right-container
                i.fa.fa-angle-left.pull-right
            ul.treeview-menu(:style="{'display': envsetting.display}")
              //-
                li
                  a(href=basedir + 'pages/envsettings/setting.html' title="基本設定")
                    span 基本設定
              //-
                li
                  a(href=basedir + '#' title="言語およびタイムゾーン設定")
                    //-i.fa.fa-fw.fa-language
                    span 言語およびタイムゾーン設定
              li(v-if="use_agency")
                router-link(:to="{name: 'InputProxySettings', params: {init: true}}" title="修正サービスの設定")
                  span 修正サービスの設定
              li
                router-link(:to="{name: 'InfoSettings', params: {init: true}}" title="お知らせの設定")
                  span お知らせの設定
              li
                router-link(:to="{name: 'Passwordpolicy', params: {init: true}}" title="パスワードポリシー")
                  span パスワードポリシー
              li
                router-link(:to="{name: 'AttachsizeSetting', params: {init: true}}" title="添付ファイルサイズ設定")
                  span 添付ファイルサイズ設定
              li
                router-link(:to="{name: 'ExpireSetting', params: {init: true}}" title="データの保存期間設定")
                  span データの保存期間設定
              li
                router-link(:to="{name: 'LicenseSetting', params: {init: true}}" title="ライセンス情報")
                  span ライセンス情報

          li
            router-link(:to="{name: 'MbLoginSetting', params: {init: true}}" title="モバイルログイン設定")
              i.fa.fa-fw.fa-sign-in
              span モバイルログイン設定
          li
            router-link(:to="{name: 'AccessLog', params: {init: true}}" title="操作ログ")
              i.fa.fa-fw.fa-file-text-o
              span 操作ログ
          li(v-if="hasNisfaLicense")
            router-link(:to="{name: 'NISFAIntegrationSettings', params: {init: true}}" title="Sales Force Assistant 連携")
              i.fa.fa-fw.fa-puzzle-piece
              span Sales Force Assistant 連携

          li.treeview(v-if="MEISHIBANK2.flags.appsIntegrate" data-type='neointegration' :class="{'menu-open': neointegration.isOpen}")
            a(href="#", @click="isOpenMenu($event)")
              i.fa.fa-fw.fa-puzzle-piece
              i.fa.fa-angle-right.hidden
              span desknet's NEO 連携
              span.pull-right-container
                i.fa.fa-angle-left.pull-right
            ul.treeview-menu(:style="{'display': neointegration.display}")
              li
                router-link(:to="{name: 'NeoConnectionSetting', params: {init: true}}" title="desknet's NEO 接続設定")
                  span desknet's NEO 接続設定
              li
                router-link(:to="{name: 'appsuite-job', params: {init: true}}" title="AppSuite データ連携設定")
                  span AppSuite データ連携設定
</template>

<script>
import Pin from './TheSidebarPin'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const TopRepository = RepositoryFactory.get('top')

export default {
  name: 'Sidebar',
  components: { Pin },
  data () {
    return {
      // 一般メニューのサイドメニュー情報
      queuesCount: 0,
      errorsCount: 0,
      noimageCount: 0,
      nonjudgedCount: 0,
      pinnedMenu: '',
      // サブメニュー開閉フラグ
      user: {
        isOpen: false,
        display: 'none'
      },
      group: {
        isOpen: false,
        display: 'none'
      },
      envsetting: {
        isOpen: false,
        display: 'none'
      },
      neointegration: {
        isOpen: false,
        display: 'none'
      }
    }
  },
  computed: {
    login_user () {
      return (this.$store.state.base.u && this.$store.getState('login_user')) || {}
    },
    /**
     * ライセンス情報取得
     * @return bool
     */
    use_agency: function () {
      const license = this.$store.getState('license')
      return (this.$store.state.base.u && license && license.contract_input) || false
    }
  },
  watch: {
    // storeのwatchの仕方は他にもある
    // https://stackoverflow.com/questions/43270159/vuejs-2-how-to-watch-store-values-from-vuex
    '$store.state.base.sidemenuReloader': function (sidemenuReloader) {
      if (sidemenuReloader) {
        this.getUserSidemenu()
      }
    }
  },
  created () {
    this.getUserSidemenu()
  },
  mounted () {
    $(this.$refs.tree).tree()

    // サブメニューの開閉チェック
    // ユーザー
    if (this.isIncludes(['user', 'user-import', 'user-export', 'user-setting'], this.$route.name)) {
      this.user.isOpen = true
      this.user.display = 'block'
    }
    // 組織
    else if (this.isIncludes(['group', 'group-import', 'group-export'], this.$route.name)) {
      this.group.isOpen = true
      this.group.display = 'block'
    }
    // 基本設定
    else if (this.isIncludes(['InfoSettings', 'InputProxySettings', 'Passwordpolicy', 'AttachsizeSetting', 'ExpireSetting', 'LicenseSetting'], this.$route.name)) {
      this.envsetting.isOpen = true
      this.envsetting.display = 'block'
    }
    // desknet's NEO 連携
    else if (this.isIncludes(['NeoConnectionSetting', 'appsuite-job'], this.$route.name)) {
      this.neointegration.isOpen = true
      this.neointegration.display = 'block'
    }
  },
  methods: {
    /**
     * サイドバーの開閉状態をクッキーに保存する
     */
    saveSidebar () {
      // サイドバーの開閉状態をチェック
      if (document.body.classList.contains('sidebar-collapse')) {
        // open
        this.setCookie('sidebar_is_open', '1')
      }
      else {
        // close
        if (window.innerWidth > 767) {
          document.body.classList.remove('sidebar-open') // 画面サイズXSの設定が残ることがあるため
        }
        this.setCookie('sidebar_is_open', '0')
      }
    },
    /**
     * treeview-menuの開閉チェック
     */
    isOpenMenu: function (e) {
      // サイドバーが閉じているときは、treeview-menuを開閉しない
      if (this.getCookie('sidebar_is_open') === this.app_flag.OFF) {
        e.preventDefault()
        e.stopPropagation()
      }
    },
    /**
     * 一般メニューのサイドメニュー情報を取得する
     */
    getUserSidemenu () {
      if (this.isAdminPage || this.isMgmt) {
        return
      }

      const vm = this
      TopRepository.getSidemenu(this.isMgmt)
        .then(function (response) {
          let data = vm.getApiData(response).data
          if (data) {
            vm.queuesCount = data.queues
            vm.errorsCount = data.errors
            vm.noimageCount = data.noimage
            vm.nonjudgedCount = data.nonjudged
            vm.pinnedMenu = data.pinned
          }
        })
        // エラー時処理
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || 'サイドメニュー情報が取得できませんでした。'
          vm.showToast(message, { type: 'danger' })
        })
    },
    /**
     * サイドメニューのバッチに表示する数字を加工する
     * @param count
     * @returns {string}
     */
    getBadgeCount (count) {
      return count > 999 ? '999+' : count
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~bootstrap-sass/assets/stylesheets/bootstrap/variables';
@import '~bootstrap-sass/assets/stylesheets/bootstrap/mixins';

// 左サイドバー
// xs幅のときはサイドバーを上にかぶせるように表示する
@media (max-width: $screen-xs-max) {
  &.sidebar-open .content-wrapper,
  &.sidebar-open .main-footer {
    -webkit-transform: translate(0,0);
        -ms-transform: translate(0,0);
         -o-transform: translate(0,0);
            transform: translate(0,0);
  }
  &.sidebar-mini:not(.sidebar-mini-expand-feature).sidebar-collapse .sidebar-menu > li:hover > .treeview-menu,
  &.sidebar-mini:not(.sidebar-mini-expand-feature).sidebar-collapse .sidebar-menu > li:hover > a > span:not(.pull-right) {
    position: static;
    width: auto;

    display: inline !important;
  }
  &.sidebar-mini:not(.sidebar-mini-expand-feature).sidebar-collapse .sidebar-menu > li:hover > a > span {
    margin-left: 0;
    padding: 0;
  }
}
.spacer-box {
  height: 51px;
}
.main-sidebar {
  // ユーザー情報と検索エリアを削除
  padding-top: 0;
  top: -51px;
  min-height: calc(100% + 51px);
  .sidebar .sidebar-menu > li > a {
    text-overflow: ellipsis;
    white-space: nowrap;
    span {
      margin-left: .3em;
    }
  }
}

// サイドバーアイコン切り替え
.main-sidebar .sidebar-toggle-close,
.sidebar-collapse .main-sidebar .sidebar-toggle-open {
  display: block;
}
.main-sidebar .sidebar-toggle-open,
.sidebar-collapse .main-sidebar .sidebar-toggle-close {
  display: none;
}

// hover時に右側に全表示しない
@media (min-width: $screen-sm-min) {
  // &.sidebar-mini:not(.sidebar-mini-expand-feature).sidebar-collapse .sidebar-menu.is-single > li:hover > a > span:not(.pull-right) {
  //   display: none !important;
  // }

  &.sidebar-mini:not(.sidebar-mini-expand-feature).sidebar-collapse .sidebar-menu > li:hover > a > span:not(.pull-right) {
    display: none !important;
  }

  .sidebar-mini:not(.sidebar-mini-expand-feature).sidebar-collapse .sidebar-menu > li:hover > .treeview-menu {
    width: 220px;
    top: 0;
  }

  .sidebar-mini.sidebar-collapse .sidebar-menu > li > .action {
    display: none !important;
  }
  // &.sidebar-mini:not(.sidebar-mini-expand-feature).sidebar-collapse .sidebar-menu > li:hover > a > .pull-right-container {
  //   position: relative !important;
  //   top: -18px !important;
  //   left: 220px !important;
  // }

  // 縮小時に区切りを表示する
  .sidebar-mini.sidebar-collapse .sidebar-menu li.header {
    position: relative;

    display: block !important;
    // visibility: hidden;
    text-indent: -9999px; // IEはhidden要素の擬似要素をvisibleにしてもhiddenにしてしまうので、回避策
    background-color: transparent;

    &:after {
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      height: 1px;

      content: '';
      display: block;
      z-index: 1;
      background-color: #ddd;
      // visibility: visible;
      text-indent: 0; // IEはhidden要素の擬似要素をvisibleにしてもhiddenにしてしまうので、回避策
    }
  }

  // 縮小時、子メニューがあることを示すアイコンを表示する
  .sidebar-mini.sidebar-collapse .sidebar-menu li.treeview .fa.fa-angle-right {
    display: inline-block !important;
    width: auto;
    margin-left: 3px;
  }
}
// 高さを狭める（mantis:42284）
.sidebar-menu {
  > li > a {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .pull-right-container {
    margin-top: -8px;
  }

  .treeview-menu > li > a {
    padding-left: 18px;
  }
}

// バッチアイコンを並べる
.sidebar-menu > li {

  > a {
    padding: 8px 15px;
    position: relative;

    .badge {
      margin: 0;
      position: absolute;
      right: 15px;
      display: inline; // adminLTEのスタイルが効かないようにdivタグで書いている
    }
  }
}
// サイドメニューを閉じたときのスタイル（ただの●ボッチ）
@media (min-width: $screen-sm-min) {
  body.sidebar-collapse .sidebar-menu > li {
    div.badge { /* build時はdivを付けてやっとdisplayの優先度が勝てる */
      display: inline-block !important;
      border-radius: 10px;
      position: absolute;
      right: 4px;
      bottom: 4px;
      padding: 0;
      width: 10px;
      height: 10px;
      text-indent: -100px;
    }
  }
}

body:not(.sidebar-collapse) .sidebar-menu > li {
  // メニューにアクションアイコンを付ける
  &.has-action {
    position: relative;

    a:first-child {
      // アクションアイコン分のスペースを空ける
      padding-right: 44px;
      @include text-overflow;
    }

    > .action {
      padding: 8px 16px 8px 8px;
      position: absolute;
      top: 0;
      right: 0;
      display: block;
      width: 44px;
      text-align: center;
      border-left: 0;

      > i {
        width: auto;
      }
    }

    // マウスカーソルを当てたときだけメニューアイコンを見せる
    > a.action {
      opacity: 0;
    }
    &:hover a.action {
      opacity: .3;
    }
    a.action:hover {
      opacity: 1;
      color: #0073b7; // .text-blue
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/TheSidebar.vue